import Vue from 'vue';
import Router from 'vue-router';
import HomePage from 'Pages/landing';
import store from 'src/store';
import AlertManipulationModes from 'src/models/AlertManipulationModes';
import PaymentModes from 'src/models/PaymentModes';
import RecentLoginsPage from 'Pages/RecentLogins';
import MessageDisplayer from 'Components/MessageDisplayer';
import AlertCreationPage from 'Pages/alertCreation';
import DashboardPage from 'Pages/Dashboard';
import HealthcheckPage from 'Pages/admin/HealthCheck';
import NotificationsPage from 'Pages/Notifications';
import UiKitPage from 'Pages/UiKit';
import AlertManagmentPage from 'Pages/AlertManagment';
import EmailConfirmPage from 'Pages/EmailConfirm';
import PageWrapper from 'Layout/PageWrapper';
import EmailChangeConfirmPage from 'Pages/EmailChangeConfirm';
import CurrencyPage from 'Pages/currency';
import CurrenciesTable from 'Common/currenciesTable';
import SettingsPage from 'Pages/settings';
import AdminPage from 'Pages/admin';
import TariffsManagePage from 'Pages/admin/TariffsManage';
import UsersInfoPage from 'Pages/admin/UsersInfo';
import EmailSendingPage from 'Pages/admin/EmailSending';
import SupportPage from 'Pages/Support';
import TermsOfUsePage from 'Pages/TermsOfUse';
import PrivacyPolicyPage from 'Pages/PrivacyPolicy';
import UnsubscribePage from 'Pages/Unsubscribe';
import ResetPasswordPage from 'Pages/ResetPassword';
import SubscriptionWrap from 'Layout/SubscriptionWrap';
import SubscriptionPlansPage from 'Pages/subscription/Plans';
import SubscriptionPaymentPage from 'Pages/subscription/Payment';
import SubscriptionManagmentPage from 'Pages/subscription/Managment';
import PaymentHistoryPage from 'Pages/paymentHistory';
import NotFoundPage from 'Pages/NotFound';
import ServerErrorPage from 'Pages/ServerError';
import AuthorizationPage from 'Components/loginTools/AuthorizationPage';
import { userMessages, prevUrlLocalStorageName } from 'src/utils/config';
import ActionBtns from 'src/models/ActionBtns';

Vue.use(Router);
function handleUnauthorisedRedirect(to, from, next) {
  if (!store.state.userData.loginInfo) {
    next(`/authorization-page?returnUrl=${to.path}`);
  } else {
    next();
  }
}

function handleAuthorisedRedirect(to, from, next) {
  if (!store.state.userData.loginInfo) {
    next();
  } else {
    next({
      path: '/all-currencies',
      replace: true,
    });
  }
}

function handleNotAdminRedirect(to, from, next) {
  if (!store.getters['userData/userIsAdmin']) {
    next('/');
  } else {
    next();
  }
}

/* eslint-disable */
function handleProdModeRedirect(to, from, next) {
  if (!__DEV__) {
    next('/');
  } else {
    next();
  }
}
/* eslint-enable */

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
      beforeEnter: handleAuthorisedRedirect,
      meta: {
        isLandingPage: true,
        dontUpdateHeaderTickersCount: true,
      },
    },
    {
      path: '/all-currencies',
      name: 'CurrenciesTable',
      component: CurrenciesTable,
      children: [
        {
          path: '',
          redirect: 'all',
        },
        {
          path: 'all',
          meta: {
            allCurrencyTabSelected: true,
            dontUpdateHeaderTickersCount: true,
            noScroll: true,
            isAllCurPage: true,
          },
        },
        {
          path: 'favourites',
          beforeEnter: (to, from, next) => {
            if (!store.state.userData.loginInfo) {
              next('/all-currencies/all');
            } else {
              next();
            }
          },
          meta: {
            favouritesTabSelected: true,
            dontUpdateHeaderTickersCount: true,
            noScroll: true,
            isAllCurPage: true,
          },
        },
      ],
    },
    {
      path: '/recent-logins',
      name: 'RecentLoginsPage',
      component: RecentLoginsPage,
      beforeEnter: handleUnauthorisedRedirect,
    },
    {
      path: '/email-confirm',
      component: PageWrapper,
      children: [
        {
          path: '',
          name: 'EmailConfirm',
          component: EmailConfirmPage,
        },
        {
          path: 'token-invalid',
          name: 'EmailConfirmTokenInvalid',
          component: MessageDisplayer,
          props: { emailConfirmedError: true },
          meta: {
            redirectOnLogin: true,
            actionBtn: ActionBtns.signup,
          },
        },
        {
          path: 'success',
          name: 'EmailConfirmSuccess',
          component: MessageDisplayer,
          props: { emailConfirmed: true },
          meta: {
            redirectOnLogin: true,
            actionBtn: ActionBtns.login,
          },
        },
      ],
    },
    {
      path: '/email-change-confirm',
      component: PageWrapper,
      children: [
        {
          path: '',
          name: 'EmailChangeConfirm',
          component: EmailChangeConfirmPage,
        },
        {
          path: 'token-invalid',
          name: 'EmailChangeTokenInvalid',
          component: MessageDisplayer,
          props: { emailConfirmedError: true },
          meta: {
            redirectOnLogin: true,
            actionBtn: ActionBtns.login,
          },
        },
      ],
    },
    {
      path: '/add-alert/:tickerId',
      name: 'AddAlert',
      component: AlertCreationPage,
      props: route => ({
        tickerId: +route.params.tickerId,
        mode: AlertManipulationModes.creating,
      }),
      meta: {
        noScroll: true,
        isAddAlertPage: true,
      },
    },
    {
      path: '/repeat-alert/:alertId',
      name: 'RepeatAlert',
      component: AlertCreationPage,
      props: route => ({
        alertId: +route.params.alertId,
        mode: AlertManipulationModes.repeating,
      }),
      meta: {
        noScroll: true,
        isAddAlertPage: true,
      },
    },
    {
      path: '/edit-alert/:alertId',
      name: 'EditAlert',
      component: AlertCreationPage,
      props: route => ({
        alertId: +route.params.alertId,
        mode: AlertManipulationModes.editing,
      }),
      meta: {
        noScroll: true,
        isAddAlertPage: true,
      },
    },
    {
      path: '/reset-password',
      component: PageWrapper,
      children: [
        {
          path: '',
          name: 'ResetPasswordPage',
          component: ResetPasswordPage,
        },
        {
          path: 'token-invalid',
          name: 'ResetPasswordTokenInvalid',
          component: MessageDisplayer,
          props: { passwordForgotError: true },
          meta: {
            redirectOnLogin: true,
          },
        },
        {
          path: 'success',
          name: 'PasswordSuccessChanged',
          component: MessageDisplayer,
          props: { passwordChanged: true },
          meta: {
            redirectOnLogin: true,
            actionBtn: ActionBtns.login,
          },
        },
      ],
    },
    {
      path: '/change-password/success',
      name: 'ChangePasswordSuccess',
      component: MessageDisplayer,
      props: { text: userMessages.passwordChangeSuccess },
      beforeEnter: handleUnauthorisedRedirect,
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: DashboardPage,
      beforeEnter: handleUnauthorisedRedirect,
    },
    {
      path: '/notifications',
      name: 'Notifications',
      component: NotificationsPage,
      beforeEnter: handleUnauthorisedRedirect,
    },
    {
      path: '/uikit',
      name: 'Ui-Kit',
      component: UiKitPage,
      // beforeEnter: handleProdModeRedirect,
    },
    {
      path: '/alert-management',
      name: 'AlertManagmentPage',
      component: AlertManagmentPage,
    },
    {
      path: '/currency/:tickerId',
      name: 'CurrencyPage',
      component: CurrencyPage,
      props: route => ({
        tickerId: +route.params.tickerId,
      }),
    },
    {
      path: '/settings',
      name: 'SettingsPage',
      component: SettingsPage,
      beforeEnter: handleUnauthorisedRedirect,
      meta: {
        isSettingsPage: true,
      },
    },
    {
      path: '/support',
      name: 'SupportPage',
      component: SupportPage,
    },
    {
      path: '/terms-of-use',
      name: 'TermsOfUsePage',
      component: TermsOfUsePage,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
    },
    {
      path: '/unsubscribe',
      name: 'UnsubscribePage',
      component: UnsubscribePage,
    },
    {
      path: '/payment-history',
      name: 'PaymentHistoryPage',
      component: PaymentHistoryPage,
      beforeEnter: handleUnauthorisedRedirect,
    },
    {
      path: '/subscription',
      beforeEnter: handleUnauthorisedRedirect,
      component: SubscriptionWrap,
      children: [
        {
          path: '',
          name: 'SubscriptionManagmentPage',
          component: SubscriptionManagmentPage,
          meta: {
            isSubscriptionManagement: true,
          },
        },
        {
          path: 'link-card',
          name: 'SubscriptionLinkCardPage',
          component: SubscriptionPaymentPage,
          props: {
            mode: PaymentModes.linkCard,
          },
        },
        {
          path: 'change-tariff',
          name: 'SubscriptionChangeTariff',
          component: SubscriptionPaymentPage,
          props: {
            mode: PaymentModes.tariff,
          },
        },
        {
          path: 'tariffs',
          name: 'SubscriptionPlansPage',
          component: SubscriptionPlansPage,
          meta: {
            isTariffsPage: true,
          },
        },
      ],
    },
    {
      path: '/admin',
      component: AdminPage,
      beforeEnter: handleNotAdminRedirect,
      children: [
        {
          path: '',
          redirect: 'healthcheck',
        },
        {
          path: 'healthcheck',
          name: 'Healthcheck',
          component: HealthcheckPage,
        },
        {
          path: 'email-sending',
          name: 'EmailSending',
          component: EmailSendingPage,
        },
        {
          path: 'tariffs-manage',
          name: 'TariffsManage',
          component: TariffsManagePage,
        },
        {
          path: 'users-info',
          name: 'UsersInfo',
          component: UsersInfoPage,
        },
      ],
    },
    {
      path: '/authorization-page',
      component: AuthorizationPage,
      beforeEnter: handleAuthorisedRedirect,
      children: [
        {
          path: '',
          redirect: 'sign-in',
        },
        {
          path: 'sign-in',
          meta: {
            isAuthorizationPage: true,
            isSignInTab: true,
          },
        },
        {
          path: 'sign-up',
          meta: {
            isAuthorizationPage: true,
            isSignUpTab: true,
          },
        },
      ],
    },
    {
      path: '/server-error',
      alias: '/oauth-error',
      props: route => ({
        needRelogin: route.query.needRelogin && route.query.needRelogin.toLowerCase() === 'true',
        errorText: route.query.errorText,
      }),
      meta: {
        redirectOnLogin: true,
      },
      name: 'ServerError',
      component: ServerErrorPage,
    },
    {
      path: '/404',
      name: '404',
      component: NotFoundPage,
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
  scrollBehavior(to) {
    if (to.meta.noScroll) {
      return;
    }
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 200);
  },
});
router.beforeEach((to, from, next) => {
  store.dispatch('userData/checkUserAuthSession').then(next);
  if (to.path !== from.path) {
    localStorage.setItem(prevUrlLocalStorageName, from.path);
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js